import { SET_UPDATENOTIFICATION } from '../actions';

const updatenotification = (state = [], action) => {
  switch (action.type) {
	case SET_UPDATENOTIFICATION:
      return [...action.value];  
    default: return state;
  }
}

export default updatenotification;
